import { PROJECT_COLORS } from "#constants/dropdownOptions"
import { type Hexcode } from "#contexts/ThemeContextProvider"
import { type ProjectConstructor } from "#customTypes/composedTypes/projectTypes"

const PROJECT_COLOR_VALUES = Object.values(PROJECT_COLORS)

export interface ProjectSchedule {
  sessionIndex: number
  project: ProjectConstructor
  fraction: number
  daysToComplete: number
  color: Hexcode
}

export const getProjectScheduleBySession = (
  projects: ProjectConstructor[]
): ProjectSchedule[] => {
  if (!projects?.length) return []

  const colorMap = new Map<string, string>()
  let colorIndex = 0

  // Assign colors to unique projects
  projects.forEach(({ id: projectId }) => {
    colorMap.set(
      projectId,
      PROJECT_COLOR_VALUES[colorIndex % PROJECT_COLOR_VALUES.length]
    )
    colorIndex++
  })

  const sessionMap: ProjectSchedule[] = []

  let sessionIndex = 0

  for (let i = 0; i < projects.length; i++) {
    const project = projects[i]

    const days = parseInt(project.daysToComplete ?? "1")

    for (let j = 0; j < days; j++) {
      sessionMap.push({
        sessionIndex,
        project,
        fraction: j + 1,
        daysToComplete: days,
        color: colorMap.get(project.id) ?? "",
      })

      sessionIndex++
    }
  }

  return sessionMap
}
